"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _reactCustomScrollbars = require("react-custom-scrollbars");
var _preventEventDoubling = require("../../../../../Utils/Events/preventEventDoubling");
var _AnalyticsWrapper = _interopRequireDefault(require("../../../../Shared/Components/Analytics/AnalyticsWrapper"));
require("./Styles.scss");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var styles = function styles() {
  return {
    imageLibraryThumbnail: {
      width: 150,
      height: 'auto',
      borderRadius: 6,
      marginBottom: 10,
      marginRight: 10,
      backgroundImage: 'linear-gradient(45deg, #F0F0F0 25%, transparent 25%), ' + 'linear-gradient(-45deg, #F0F0F0 25%, transparent 25%), ' + 'linear-gradient(45deg, transparent 75%, #F0F0F0 75%), ' + 'linear-gradient(-45deg, transparent 75%, #F0F0F0 75%)',
      backgroundSize: '20px 20px',
      backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    imageContainer: {
      position: 'relative',
      display: 'inline-block'
    },
    priceLabel: {
      position: 'absolute',
      background: '#0000005E',
      borderRadius: 6,
      padding: '4px',
      bottom: '15px',
      right: '10px'
    },
    priceLabelText: {
      color: '#ffffff'
    },
    activeGalleryImage: {
      border: '2px solid #ED1C29'
    },
    inactiveGalleryImage: {
      border: '1px solid #0000005E',
      padding: 1
    }
  };
};
var motivesWrapper = {
  maxHeight: 600,
  minHeight: 355
};
var ImageThumbnail = (0, _styles.withStyles)(styles, {
  name: 'ImageThumbnail'
})(function (_ref) {
  var selected = _ref.selected,
    classes = _ref.classes,
    motive = _ref.motive,
    onSelect = _ref.onSelect,
    hidePrices = _ref.hidePrices;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/_react["default"].createElement(_AnalyticsWrapper["default"], {
    targetId: "image_thumbnail_select",
    data: motive
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: classes.imageLibraryThumbnail + ' ' + (selected === motive ? classes.activeGalleryImage : classes.inactiveGalleryImage),
    src: _typeof(motive) === 'object' ? motive.url : motive,
    alt: _typeof(motive) === 'object' ? motive.title : motive,
    onClick: function onClick() {
      onSelect(motive);
    }
  })), !hidePrices && _typeof(motive) === 'object' && motive.priceFormatted !== null && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.priceLabel
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: classes.priceLabelText,
    variant: "body2"
  }, motive.priceFormatted)));
});
var ImageLibraryThumbnail = /*#__PURE__*/function (_React$Component) {
  _inherits(ImageLibraryThumbnail, _React$Component);
  var _super = _createSuper(ImageLibraryThumbnail);
  function ImageLibraryThumbnail() {
    var _this;
    _classCallCheck(this, ImageLibraryThumbnail);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onSelect", (0, _preventEventDoubling.preventEventDoubling)(function (item) {
      var onSelect = _this.props.onSelect;
      onSelect && onSelect(item);
    }));
    return _this;
  }
  _createClass(ImageLibraryThumbnail, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        motives = _this$props.motives,
        selected = _this$props.selected,
        client = _this$props.client;
      var query = new URLSearchParams(location.search);
      var hidePrices = query.has('_hide_prices') ? query.get('_hide_prices') === '1' : client && !!client.hidePrices;
      return /*#__PURE__*/_react["default"].createElement(_reactCustomScrollbars.Scrollbars, {
        autoHeightMin: 250,
        autoHide: true,
        renderThumbVertical: function renderThumbVertical(props) {
          return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
            className: "thumb-vertical"
          }));
        },
        renderTrackVertical: function renderTrackVertical(props) {
          return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
            className: "track-vertical"
          }));
        },
        style: motivesWrapper
      }, motives.map(function (motive, i) {
        return /*#__PURE__*/_react["default"].createElement(ImageThumbnail, {
          key: i,
          motive: motive,
          onSelect: _this2.onSelect,
          selected: selected,
          hidePrices: hidePrices
        });
      }));
    }
  }]);
  return ImageLibraryThumbnail;
}(_react["default"].Component);
var _default = exports["default"] = ImageLibraryThumbnail;